<script>
  import HomeHero from '$lib/home/hero/Index.svelte';
  import HomeAbout from '$lib/home/About.svelte';
  import Quote from '$lib/Quote.svelte';
  import HomePortfolio from '$lib/home/Portfolio.svelte';
  import Projects from '$lib/Projects.svelte';
  import NewStats from '$lib/home/stats-new/Index.svelte';
  import HomeLinks from '$lib/home/Links.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';

  export let hero;
  export let about;
  export let quote;
  export let portfolio;
  export let projects;
  export let newStats;
  export let homeLinks;
  export let seo;
  export let faq;
</script>

<HomeHero {hero} />
{#if about}
  <HomeAbout {about} />
{/if}
{#if newStats}
  <NewStats {newStats} />
{/if}
{#if portfolio}
  <HomePortfolio {portfolio} />
{/if}
{#if quote}
  <Quote {...quote} />
{/if}
{#if homeLinks}
  <HomeLinks {homeLinks} />
{/if}
{#if projects}
  <Projects {projects} light={true} />
{/if}
{#if seo}
  <Seo {seo} />
{/if}
{#if faq}
  <Faq {faq} />
{/if}
